jQuery( document ).ready(function($) {
    $('[data-toggle="tooltip"]').tooltip({trigger: 'hover'});
});



// WEBPACK FOOTER //
// ./private/js/tooltip.js